import { a } from 'react-spring/three'
import { Text } from '@react-three/drei'

const AnimatedText = a(Text)
/**
 * the animated object transforms an arbitrary react component into a animatable one
 */
export default AnimatedText
